import { PlacedSidePanel } from 'components/secondaryMarket/limitOrder/sidePanel/placed/PlacedSidePanel';
import { connect } from 'react-redux';
import type { FormOwnProps } from 'shared/connect/connect';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import { limitOrderTradeSelectors as limitOrderOrderSelectors } from 'state/secondaryMarket/limit-order/order/order.selector';
import { limitOrderReferentialSelectors } from 'state/secondaryMarket/limit-order/referential/referential.selector';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import { getUserPreferencesSecondaryMarketCloseTabWhenOrderPlacedActivated } from 'state/selectors';
import { isSecondaryOrderBlotterVisible } from 'state/selectors/common/router';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type PlacedSidePanelStateProps = {
  currency: string;
  priceType: SecondaryPriceType;
  validationErrors?: SecondaryMarketFormError[];
  closeTabWhenOrderIsPlacedActivated: boolean;
  traderLabel?: string;
  tradeWay: TradeWay;
  settlementDate?: string;
  cashAmount?: number;
  tradeDate?: string;
  quantity?: number;
  id?: string;
  isin?: string;
  ric?: string;
  fileCode?: string;
  clientLimit?: number;
  execTime: string;
  hasOrderBlotter?: boolean;
};

type PlacedSidePanelDispatchProps = {
  onDone: (closeTab?: boolean) => void;
};

type PlacedSidePanelOwnProps = FormOwnProps;

export type PlacedSidePanelProps = PlacedSidePanelDispatchProps & PlacedSidePanelOwnProps & PlacedSidePanelStateProps;

const mapStateToProps = (state: AppState, { formId }: PlacedSidePanelOwnProps): PlacedSidePanelStateProps => {
  return {
    closeTabWhenOrderIsPlacedActivated: getUserPreferencesSecondaryMarketCloseTabWhenOrderPlacedActivated(state),
    priceType: limitOrderReferentialSelectors.getPriceType(state, formId)!,
    settlementDate: limitOrderOrderSelectors.getTradeSettlementDate(state, formId),
    tradeWay: limitOrderOrderSelectors.getTradeTradeWay(state, formId)!,
    validationErrors: limitOrderOrderSelectors.getTradeValidationErrors(state, formId),
    cashAmount: limitOrderSelectors.getFormCashAmount(state, formId),
    tradeDate: limitOrderOrderSelectors.getTradeTradeDate(state, formId),
    id: limitOrderOrderSelectors.getOrderId(state, formId),
    quantity: limitOrderOrderSelectors.getTradeQuantity(state, formId),
    clientLimit: limitOrderOrderSelectors.getOrderLimit(state, formId),
    currency: limitOrderReferentialSelectors.getCurrency(state, formId)!,
    fileCode: limitOrderReferentialSelectors.getFileCode(state, formId),
    isin: limitOrderReferentialSelectors.getIsin(state, formId),
    ric: limitOrderReferentialSelectors.getRic(state, formId),
    traderLabel: limitOrderReferentialSelectors.getTraderLabel(state, formId),
    execTime: limitOrderOrderSelectors.getOrderExecTime(state, formId)!,
    hasOrderBlotter: isSecondaryOrderBlotterVisible(state),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { formId: tabId }: PlacedSidePanelOwnProps,
): PlacedSidePanelDispatchProps => {
  return {
    onDone: () => {
      dispatch(limitOrderThunks.finishLimitOrderThunk(tabId));
    },
  };
};

export const connectPlacedSidePanel = connect(mapStateToProps, mapDispatchToProps);

export const ConnectedPlacedSidePanel = connectPlacedSidePanel(PlacedSidePanel);
